import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1ProjectPlanPhaseMilestoneEmployeeIDOCToArray, V1ProjectPlanPhaseMilestoneReferenceIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import MemoryContext from "../../../../util/MemoryContext";


class ProjectPlanPhaseMilestoneEmployeeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseMilestoneEmployee-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseMilestoneEmployee-001";

        let fk = {};
        fk["ProjectPlanPhaseMilestoneUSID"] = foreignKey;

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/project_plan_phase_milestone_employees",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneEmployeeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhaseMilestoneEmployee-001";
        payload.ShifamedMessage.ProjectPlanPhaseMilestoneEmployee = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/project_plan_phase_milestone_employees",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestoneEmployee-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestoneEmployee-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneEmployeeIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let employee = {};

        employee["USID"] = this.getAttributeValue("USID");
        employee["EmployeeUSID"] = this.getAttributeValue("EmployeeUSID");
        employee["ProjectPlanPhaseMilestoneUSID"] = MemoryContext.components["ProjectPlanDetail-EO-MilestoneUSID"];

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhaseMilestoneEmployee-001";
        payload.ShifamedMessage.ProjectPlanPhaseMilestoneEmployee = employee;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/project_plan_phase_milestone_employees",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestoneEmployee-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestoneEmployee-001",
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneEmployeeIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhaseMilestoneEmployee-001";
        payload.ShifamedMessage.ProjectPlanPhaseMilestoneEmployee = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t3/v1/project_plan_phase_milestone_employees",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestoneEmployee-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestoneEmployee-001",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default ProjectPlanPhaseMilestoneEmployeeEnterpriseComponent;